import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default' | 'elevated';
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  variant = 'default',
  noPadding = false,
  ...props
}: CardProps) {
  const baseStyles = 'rounded-xl border border-white/5 transition-all duration-200';
  const bgStyles = variant === 'elevated' ? 'bg-background-elevated' : 'bg-background-card';
  const paddingStyles = noPadding ? '' : 'p-6';
  return <div className={`${baseStyles} ${bgStyles} ${paddingStyles} ${className}`} {...props} data-id="element-189">
      {children}
    </div>;
}